export default "__VITE_ASSET__Dqm$hpzy__"